import Api from "../lib/api";
import ModalForm from "./base/forms/modal-form";
import {AnalyticsService} from "../services/analytics-service";

export default class Consent {
    constructor() {
        this.$consentBanner = document.querySelector('.consent-banner');
        this.$acceptAll = this.$consentBanner.querySelector('.consent-banner_accept-all');
        this.$reject = this.$consentBanner.querySelector('.consent-banner_reject');
        this.$settingsAcceptSome = document.getElementById('consentSettingsAcceptSome');
        this.$settingsAcceptAll = document.getElementById('consentSettingsAcceptAll');

        this.init();
    }

    init() {
        Api.get(Api.restSiteUrl + '/1.0/helper/geoip')
            .then((res) => {
                const consentMode = costorage.get('h_consentMode');
                const consentModeData = consentMode ? JSON.parse(consentMode) : null;

                if (res.isEEA && (!consentModeData || Object.keys(consentModeData).length !== AnalyticsService.consentModeTypes.length)) {
                    this.showBanner();
                }

                const consentSettingsForm = new ModalForm({
                    formId: 'consent-settings',
                    uri: '/',
                    $modalTriggers: Array.from(document.querySelectorAll('[data-modal-trigger="consent-settings"]')),
                    initialValues: {
                        necessary: true,
                        marketing: consentModeData ? consentModeData.ad_storage === 'granted' && consentModeData.ad_user_data === 'granted' : true,
                        analytics: consentModeData ? consentModeData.analytics_storage === 'granted' : true,
                        preferences: consentModeData ? consentModeData.personalization_storage === 'granted' && consentModeData.ad_personalization === 'granted' : true
                    },
                    afterOpen: () => {
                        this.hideBanner();
                    },
                    beforeClose: () => {
                        this.hideBanner();
                    }
                });

                this.$acceptAll.addEventListener('click', () => {
                    this.acceptAll();
                    this.hideBanner();
                });

                this.$reject.addEventListener('click', () => {
                    this.reject();
                    this.hideBanner();
                });

                this.$settingsAcceptAll.addEventListener('click', () => {
                    this.acceptAll();
                    consentSettingsForm.close();
                });

                this.$settingsAcceptSome.addEventListener('click', () => {
                    consentSettingsForm.collectData();
                    AnalyticsService.setConsent({
                        necessary: consentSettingsForm.data.necessary,
                        marketing: consentSettingsForm.data.marketing,
                        analytics: consentSettingsForm.data.analytics,
                        preferences: consentSettingsForm.data.preferences
                    });
                    consentSettingsForm.close();
                });
            });
    }

    showBanner() {
        setTimeout(() => {
            this.$consentBanner.style.display = null;

            setTimeout(() => {
                this.$consentBanner.classList.add('-visible');
            }, 20);
        }, 3000);
    }

    hideBanner() {
        this.$consentBanner.classList.remove('-visible');
    }

    acceptAll() {
        AnalyticsService.setConsent({
            necessary: true,
            marketing: true,
            analytics: true,
            preferences: true
        });
    }

    reject() {
        AnalyticsService.setConsent({
            necessary: true,
            marketing: false,
            analytics: false,
            preferences: false
        });
    }
}